<template>
    <div class="postComment">
        <TextField class="comment avatarField"
            v-model="comment"
            id="comment"
            type="textarea"
            :label="siteContent.commentAs + ' ' + loggedInUser.name"></TextField>
        <img class="avatar"
            :src="avatar"
            :alt="'avatar of ' + loggedInUser.name"/>
        <div :class="['iconWrapper', state]"
            @click="postComment"
            tabindex="0">
            <Icon class="sendIcon"
                icon="send"
                size="l"
                appearance="inherit"/>
        </div>
    </div>
</template>

<script>
    import { db } from '@/firebase'
    import { mapActions } from 'vuex'

    export default {
        name: 'PostComment',
        data() {
            return {
                comment: ''
            }
        },
        props: {
            collection: {
                type: String,
                required: true
            },
            documentId: {
                type: String,
                required: true
            },
            notificationDetails: {
                type: Object,
                required: true
            }
        },
        computed: {
            state() {
                if(this.comment.length === 0) {
                    return 'disabled'
                } else {
                    return 'default'
                }
            },
            avatar() {
                if(this.loggedInUser.avatar) {
                    return this.loggedInUser.avatar
                } else {
                    return this.constants.defaults.avatar
                }
            }
        },
        methods: {
            ...mapActions('notifications',['createNotification']),

            async postComment() {
                if(this.comment.length === 0) {
                    return
                }

                try {
                    // Handle comment
                    var comment = {
                        timestamp: new Date(),
                        writtenBy: this.auth.id,
                        doc:       this.documentId,
                        content:   this.comment,
                    }
                    
                    await db
                        .collection(this.collection)
                        .doc()
                        .set(comment)

                    this.comment = ''

                } catch(err) {
                    console.log(err)
                }

                try {
                    // Update last comment date
                    var userRef = await db
                        .collection('users')
                        .doc(this.auth.id)
                        .get()

                    var userData = userRef.data()

                    userData.activity.lastCommentDate = new Date

                    await db
                        .collection('users')
                        .doc(this.auth.id)
                        .update(userData)
                } catch(error) {
                    throw error
                }

                // Create notification if not own doc
                if(this.notificationDetails.createdBy !== this.auth.id) {
                    try {
                        var notification = {
                            type:       'newComment',
                            docID:       this.documentId,
                            collection:  this.collection,
                            createdBy:   this.auth.id,
                            timestamp:   new Date(),
                            title:       this.notificationDetails.title,
                            recipients:  [ this.notificationDetails.createdBy ]
                        }

                        await this.createNotification({
                            notification: notification
                        })
                    } catch(err) {
                        console.log(err)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .postComment {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 3rem;
    }

    .comment {
        margin-right: 0.5rem;
    }

    .iconWrapper {
        padding: 0.75rem;
        border-radius: 0.75rem;
        transition: $transition-eio-20;
        outline: 0;

        &:focus {
            box-shadow: var(--shadow-focus-s);
        }
    }

    .disabled {
        color: var(--color-grey-500);
    }

    .default {
        color: var(--color-primary-500);
    }

    .avatar {
        position: absolute;
        z-index: 1;
        height: 2rem;
        width: 2rem;
        object-fit: cover;
        display: block;
        border-radius: 0.75rem;
        left: 0.75rem;
        top: 1.1rem;
    }
</style>